module.exports = __webpack_public_path__ + "img/leeb-balkone-mitarbeiter-6.6419e750.jpeg";